@if (data) {
  @switch (data.layout) {
    @case (layout.LAYOUT1) {
      <app-hero-layout-1 [data]="data.data" />
    }
    @case (layout.LAYOUT2) {
      <app-hero-layout-2 [data]="data.data" />
    }
    @case (layout.LAYOUT3) {
      <app-hero-layout-3 [data]="data.data" />
    }
    @case (layout.LAYOUT4) {
      <app-hero-layout-4 [data]="data.data" />
    }
  }
}
